import React from 'react';
import { useSelector } from 'react-redux';

import { Panel } from '../../components/layout/layout';
import HorizontalBars from '../../components/charts/chartjs/horizontal-bars/HorizontalBars';
import { SONAR_DATA_KEYS } from '../../utils/chart';
import { sonarDomainsSelector, getSonarPowerrankData } from '../../redux/sonar/sonarSelectors';

function Powerrank() {
  const domainEntries = useSelector(sonarDomainsSelector) || [];

  const resultDomainEntries = getSonarPowerrankData(domainEntries || []);

  return (
    <Panel>
      <HorizontalBars data={resultDomainEntries} dataKey={SONAR_DATA_KEYS.POWERRANK} customTooltip />
    </Panel>
  );
}

export default Powerrank;
